@if(visible()){
<div>
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>

  @for(item of items;track item){
  <div><app-tag [label]="item[displayExpr()]" (remove)="remove(item)"></app-tag> </div>
  }
</div>
}